import { useCallback } from "react";
import { useLocation, useSearchParams } from "react-router";

export const useFromParam = () => {
  const { pathname, search } = useLocation();
  const [searchParams] = useSearchParams();

  const currentUrl = `${pathname}${search}`;

  const withFrom = useCallback(
    (path: string, params?: Record<string, string>) => {
      const [basePath, baseQuery] = path.split("?");
      const query = new URLSearchParams(baseQuery);

      Object.entries(params ?? {}).forEach(([name, value]) => query.set(name, value));
      query.set("from", currentUrl);

      return `${basePath}?${query}`;
    },
    [currentUrl]
  );

  return { from: searchParams.get("from"), currentUrl, withFrom };
};
